import { DatacenterV2, VCenter } from 'vrlcm-gui-types';
import * as Constants from '../constants/action-constants';

export interface RequestDatacenters {
  type: Constants.REQUEST_DATACENTERS;
  payload: {
    fetchChildren: boolean;
  };
}

export interface RequestDatacentersSuccess {
  type: Constants.REQUEST_DATACENTERS_SUCCESS;
  payload: {
    fetchChildren: boolean;
    datacenters: DatacenterV2[];
  };
}

export interface RequestDatacentersFailed {
  type: Constants.REQUEST_DATACENTERS_FAILED;
}

export interface UpdateDatacenter {
  type: Constants.UPDATE_DATACENTER;
  payload: {
    datacenter: DatacenterV2;
    isEdit: boolean;
  };
}

export interface UpdateDatacenterSuccess {
  type: Constants.UPDATE_DATACENTER_SUCCESS;
  payload: {
    datacenter: DatacenterV2;
    isEdit: boolean;
  };
}

export interface UpdateDatacenterFailed {
  type: Constants.UPDATE_DATACENTER_FAILED;
}

export interface UpdateVCenter {
  type: Constants.UPDATE_VCENTER;
  payload: {
    isEdit: boolean;
    dataCenterVmid: string;
    vCenter: VCenter;
  };
}

export interface UpdateVCenterSuccess {
  type: Constants.UPDATE_VCENTER_SUCCESS;
  payload: {
    dataCenterVmid: string;
    vCenter: VCenter;
    isEdit: boolean;
  };
}

export interface UpdateVCenterFailed {
  type: Constants.UPDATE_VCENTER_FAILED;
}

export interface DeleteDatacenter {
  type: Constants.DELETE_DATACENTER;
  payload: {
    dataCenterVmid: string;
  };
}

export interface DeleteVCenter {
  type: Constants.DELETE_VCENTER;
  payload: {
    dataCenterVmid: string;
    vCenterName: string;
  };
}

export type DatacenterAction =
  | RequestDatacenters
  | RequestDatacentersSuccess
  | RequestDatacentersFailed
  | UpdateDatacenter
  | UpdateDatacenterSuccess
  | UpdateDatacenterFailed
  | UpdateVCenter
  | UpdateVCenterSuccess
  | UpdateVCenterFailed
  | DeleteDatacenter
  | DeleteVCenter;

export const requestDatacenters = (
  fetchChildren = true
): RequestDatacenters => ({
  type: Constants.REQUEST_DATACENTERS,
  payload: { fetchChildren }
});

export const requestDatacentersSuccess = (
  fetchChildren = true,
  datacenters: DatacenterV2[]
): RequestDatacentersSuccess => ({
  type: Constants.REQUEST_DATACENTERS_SUCCESS,
  payload: { fetchChildren, datacenters }
});

export const requestDatacentersFailed = (): RequestDatacentersFailed => ({
  type: Constants.REQUEST_DATACENTERS_FAILED
});

export const updateDatacenter = (
  datacenter: DatacenterV2,
  isEdit: boolean
): UpdateDatacenter => ({
  payload: { datacenter, isEdit },
  type: Constants.UPDATE_DATACENTER
});

export const updateDatacenterSuccess = (
  datacenter: DatacenterV2,
  isEdit: boolean
): UpdateDatacenterSuccess => ({
  type: Constants.UPDATE_DATACENTER_SUCCESS,
  payload: { datacenter, isEdit }
});

export const updateDatacenterFailed = (): UpdateDatacenterFailed => ({
  type: Constants.UPDATE_DATACENTER_FAILED
});

export const updateVCenter = (
  isEdit: boolean,
  dataCenterVmid: string,
  vCenter: VCenter
): UpdateVCenter => ({
  type: Constants.UPDATE_VCENTER,
  payload: { isEdit, vCenter, dataCenterVmid }
});

export const updateVCenterSuccess = (
  isEdit: boolean,
  dataCenterVmid: string,
  vCenter: VCenter
): UpdateVCenterSuccess => ({
  type: Constants.UPDATE_VCENTER_SUCCESS,
  payload: { isEdit, vCenter, dataCenterVmid }
});

export const updateVCenterFailed = (): UpdateVCenterFailed => ({
  type: Constants.UPDATE_VCENTER_FAILED
});

export const deleteDatacenter = (dataCenterVmid: string): DeleteDatacenter => ({
  type: Constants.DELETE_DATACENTER,
  payload: { dataCenterVmid }
});

export const deleteVCenter = (
  dataCenterVmid: string,
  vCenterName: string
): DeleteVCenter => ({
  type: Constants.DELETE_VCENTER,
  payload: { dataCenterVmid, vCenterName }
});
